const Banner = ({ image }) => {
    return (
      <div className="w-full max-w-7xl mx-auto rounded-2xl overflow-hidden shadow-lg mt-6">
        <img
          src={image}
          alt="Banner"
          className="w-full h-[70vh] sm:h-[60vh] md:h-[65vh] lg:h-[70vh] object-cover"
        />
      </div>
    );
  };
  
  export default Banner;
  